import React from 'react';
import propTypes from 'prop-types';
import {
  Form,
  FormGroup,
  Button,
  Input,
  Label
} from 'reactstrap';

import {
  customerReviewStatusOptions,
  customerReviewSourceOptions
} from '../../../../constants/kickavenue';
import { FilterPanelBody, RadioGroupFieldset, GroupLegend, RadioRow, ApplyWrap } from '../../styled';

// "All" omits the parameter rather than sending a value.
const ALL_VALUE = '';

const Radio = ({ name, value, label, checked, onChange }) => (
  <FormGroup check>
    <Label check>
      <Input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      /> { label }
    </Label>
  </FormGroup>
)

const RadioGroup = ({ name, legend, value, options, onChange }) => (
  <RadioGroupFieldset>
    <GroupLegend>{ legend }</GroupLegend>
    <RadioRow>
      <Radio
        name={name}
        value={ALL_VALUE}
        label="All"
        checked={value === ALL_VALUE}
        onChange={onChange}
      />
    </RadioRow>
    <RadioRow>
      { options.map(option => (
        <Radio
          key={option.value}
          name={name}
          value={option.value}
          label={option.label}
          checked={value === option.value}
          onChange={onChange}
        />
      )) }
    </RadioRow>
  </RadioGroupFieldset>
)

const FilterForm = props => (
  <Form onSubmit={props.onSubmit}>
    <FilterPanelBody>
      <p className="mb-0">Filter By :</p>
      <RadioGroup
        name="status"
        legend="Status"
        value={props.status}
        options={customerReviewStatusOptions}
        onChange={props.onInputChange}
      />
      <RadioGroup
        name="source"
        legend="Source"
        value={props.source}
        options={customerReviewSourceOptions}
        onChange={props.onInputChange}
      />
      <ApplyWrap>
        <Button color="primary" disabled={props.isLoading}>Apply Filter</Button>
      </ApplyWrap>
    </FilterPanelBody>
  </Form>
)

export default FilterForm;

FilterForm.propTypes = {
  status: propTypes.string,
  source: propTypes.string,
  isLoading: propTypes.bool,
  onInputChange: propTypes.func.isRequired,
  onSubmit: propTypes.func.isRequired
}

FilterForm.defaultProps = {
  status: '',
  source: '',
  isLoading: false
}
